






















































import _ from 'lodash'
import Component, { mixins } from 'vue-class-component'
import BankTxImport from '@/modules/bank/transaction/import/domain/bankTxImport'
import bookmarkableComponent from '@/modules/common/mixins/bookmarkableComponent'
import box from '@/modules/common/components/box.vue'
import documentUpload from '@/modules/document/components/documentUpload.vue'
import Document from '@/modules/document/domain/document'
import documentField from '@/modules/common/components/form/documentField.vue'
import EntityFetchParams from '@/modules/common/store/entityFetchParams'
import { FORMAT_SYSTEM_DATE } from '@/utils'
import loading from '@/modules/common/components/loading.vue'
import noRecords from '@/modules/common/components/noRecords.vue'
import notificationService from '@/modules/common/services/notificationService'
import EntityCreateParams from '@/modules/common/store/entityCreateParams'
import entityTableMixin from '@/modules/common/mixins/entityTableMixin'
import dateRangeField from '@/modules/common/components/form/dateRangeField.vue'
import Range from '@/modules/common/components/form/range'
import moment from 'moment/moment'
import { Watch } from 'vue-property-decorator'

class Filter {
  range?: Range | null = null
}

@Component({
  components: { dateRangeField, box, documentUpload, documentField, loading, noRecords }
})
export default class BankTxImportPage extends mixins<entityTableMixin<BankTxImport>>(bookmarkableComponent, entityTableMixin) {
  entityModuleName = 'bankTxImport'
  activeSupport = false
  filter = new Filter()

  defaultFilter () {
    this.filter.range = new Range(moment().subtract(1, 'year'))
  }

  @Watch('filter.range')
  onRangeChanged (rangeNew?: Range, rangeOld?: Range) {
    if (!rangeNew && rangeOld) {
      this.fetch()
    }
  }

  documentUploaded (document: Document) {
    const bankTxImport = new BankTxImport({ document: document })
    this.$store.dispatch('bankTxImport/create', new EntityCreateParams(bankTxImport, true)).then((result) => {
      if (result) {
        notificationService.success('bank-tx-import.upload.success')
        this.$emit('close')
      }
    })
  }

  createFilter () {
    const dateFrom = this.filter.range && this.filter.range.from && this.filter.range.from.isValid()
      ? FORMAT_SYSTEM_DATE(this.filter.range.from) : null
    const dateTo = this.filter.range && this.filter.range.to && this.filter.range.to.isValid()
      ? FORMAT_SYSTEM_DATE(this.filter.range.to) : null

    return _.pickBy({
      'date-from': dateFrom,
      'date-to': dateTo
    }, _.identity)
  }

  async beforeFetch () {
    await this.$store.dispatch('bankTxImport/clearAll')
    this.fetchActionParams = new EntityFetchParams(true, this.createFilter())
  }
}
